import Loadable from "react-loadable";

const LazyDevelopment = Loadable({
  loader: () => import(/* webpackChunkName: 'development' */ "./index"),
  loading: () => 'loading...'
});

export default LazyDevelopment;
